import type { HttpClientInterface } from '../http-client/http-client.interface.ts';
import { monitoringError } from '../monitoring/monitoring-schema.ts';
import { validate } from '../validation/index.ts';
import type { RequestProps } from './api-gateway.types.ts';

export class APIGateway {
  private readonly httpClient: HttpClientInterface;

  constructor(httpClient: HttpClientInterface) {
    this.httpClient = httpClient;
  }

  async request<TInput, TOutput>({ config, inputSchema, outputSchema, domain }: RequestProps<TInput, TOutput>) {
    const mergedConfig = domain ? { ...config, domain } : config;
    try {
      if (inputSchema) {
        const inputValidation = validate(inputSchema, mergedConfig.data);
        if (!inputValidation.success) {
          monitoringError({ error: inputValidation.error, method: mergedConfig.method, path: mergedConfig.url, tag: 'ZodError' });
        }
      }

      const response = await this.httpClient.request<TOutput>(mergedConfig);

      if (outputSchema) {
        const outputValidation = validate<TOutput>(outputSchema, response.data);
        if (!outputValidation.success) {
          monitoringError({ error: outputValidation.error, method: mergedConfig.method, path: mergedConfig.url, tag: 'ZodError' });
          return response;
        }

        return { ...response, data: outputValidation.data };
      }

      return response;
    } catch (error) {
      console.error('API Gateway Error:', error);
      throw error;
    }
  }
}
